<div class="modal-header">
    <h4 class="modal-title">{{'Planlagte timer for ' + month + '-' + year}}</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <div class="table__viewport">
        <table class="table table-hover table-striped table-sm table-frame__body">
            <thead class="fixed-top position-fixed position-sticky">
            <tr>
                <th>Kundenr</th>
                <th>Navn</th>
                <th>Sag</th>
                <th>Timer</th>
            </tr>
            </thead>

            <tbody>
                <tr [ngbTooltip]="!item.sag.locked ? 'Ressourceplanlægning ikke godkendt!' : ''" [class.text-danger]="!item.sag.locked" class="item__tr" *ngFor="let item of timebudgets">
                    <td> {{ item.kundeNr }} </td>
                    <td> {{ item.kundeNavn }} </td>
                    <td> {{ item.name }} </td>
                    <td class="text-end"> {{ item.hours | time }} </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
